module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_SpatialResearch.0aeeb27f.png";